module.exports = __webpack_public_path__ + "static/media/temp-program-1.425af3b2.jpg";